import { render, staticRenderFns } from "./VehicleSelectionStep.vue?vue&type=template&id=a64db2ca&scoped=true&"
import script from "./VehicleSelectionStep.vue?vue&type=script&lang=js&"
export * from "./VehicleSelectionStep.vue?vue&type=script&lang=js&"
import style0 from "./VehicleSelectionStep.vue?vue&type=style&index=0&id=a64db2ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a64db2ca",
  null
  
)

export default component.exports